import addMinutes from 'date-fns/addMinutes';
import { isAfter, isBefore } from 'date-fns';
import moment from 'moment-timezone';
import { Timestamp } from '../services/Timestamp';

export const getLocalTimestampFromDate = (date: Date, timezone: string): Timestamp => {
  const utcDate = addMinutes(date, -date.getTimezoneOffset());
  return getLocalTimestampFromUtcDate(utcDate, timezone);
};

export const getLocalTimestampFromUtcDate = (utcDate: Date, timezone: string): Timestamp => {
  const offset = timezone ? moment.tz.zone(timezone).utcOffset(utcDate.valueOf()) : 0;
  const localTimeOffset = Timestamp.fromMinutes(-offset);
  return Timestamp.fromDate(utcDate).subtract(localTimeOffset);
};

export const isCurrentMonth = (date: Date): boolean => {
  const now = new Date();
  return date.getMonth() === now.getMonth();
};

export const isSixMonthsBefore = (date: Date): boolean => {
  const sixMonthsBefore = new Date(new Date().setMonth(new Date().getMonth() - 6));
  return isBefore(date, sixMonthsBefore);
};

export const isFuture = (date: Date): boolean => {
  return isAfter(date, new Date());
};
